import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
    methods: {
        getCurrentTimezone() {
            return dayjs.tz.guess()
        },

        //FORMAT UTC TO LOCAL TIME
        getLocalDateTime(dateUTC) {
            return dayjs.utc(dateUTC).tz(this.getCurrentTimezone()).format()
        },
    },
}
